// ** React Imports
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getBlogByid } from "@store/action/smartend/TopicAction";
import { useDispatch, useSelector } from "react-redux";
import { Link, useRouteMatch } from "react-router-dom";
import { Col, Row, Spinner } from "reactstrap";
import { Mail } from "react-feather";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  FacebookMessengerShareButton,
  EmailShareButton,
  FacebookMessengerIcon,
  WhatsappIcon,
} from "react-share";
import BreadCrumbs from "@components/breadcrumbs/index1";
import SwiperAutoplay from "./SwiperAutoplay";
import DOMPurify from "dompurify";
import Comment from "./Comment";
import Filter from "../Filter";

const SmartendId = () => {
  const { t } = useTranslation();
  const createMarkup = (html) => {
    return {
      __html: DOMPurify.sanitize(html),
    };
  };
  const shareUrl = window.location.href;
  const dispatch = useDispatch();
  const store = useSelector((state) => state.NewsReducer);
  const datas = store.single;
  const { id, webmasterTitle } = useRouteMatch().params;
  useEffect(() => {
    dispatch(getBlogByid(webmasterTitle, id));
  }, [dispatch, webmasterTitle, id]);

  const full_name =
    datas &&
    datas.Topic.created_by_user &&
    datas.Topic.created_by_user?.first_name +
      " " +
      datas.Topic.created_by_user?.last_name;

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={`${t(webmasterTitle)} Details`} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter t={t} dispatch={dispatch} setCurrentPage={() => {}} />
            {datas ? (
              <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 blog_responsive">
                <div className="blog_category_box_wrapper blog_box_wrapper float_left">
                  <div className="blog_news_img_wrapper float_left">
                    <img
                      src={datas?.Topic.photo_file && datas?.Topic.photo_file}
                      height="500px"
                      alt="blog_img"
                    />
                  </div>
                  <div className="lest_news_cont_wrapper float_left">
                    <div className="blog_heaidng_top">
                      <span>
                        <i className="flaticon-calendar" />
                        {datas?.Topic.date}
                      </span>
                      <h3>
                        <a>{datas?.Topic.title}</a>
                      </h3>
                      {t("By")}{" "}
                      <Link
                        to={`/dataNews/${webmasterTitle}/topics/created_by/${datas?.Topic?.created_by_user?.id}`}
                      >
                        {full_name}
                      </Link>
                    </div>
                    <div className="blog-single_cntnt">
                      <p
                        className="preview"
                        dangerouslySetInnerHTML={createMarkup(
                          datas?.Topic.details
                        )}
                      ></p>
                      <ul className="icon_list_news  detail_icon_lists">
                        <FacebookShareButton url={shareUrl}>
                          <li>
                            <a className="fb">
                              <i className="fab fa-facebook-f" />
                              <br /> Facebook
                            </a>
                          </li>
                        </FacebookShareButton>
                        <TwitterShareButton url={shareUrl}>
                          <li>
                            <a className="twit">
                              <i className="fab fa-twitter" />
                              <br /> twitter
                            </a>
                          </li>
                        </TwitterShareButton>
                        <WhatsappShareButton url={shareUrl}>
                          <li>
                            <a className="share">
                              <WhatsappIcon size={34} round={true} />
                              <br /> Whatsapp
                            </a>
                          </li>
                        </WhatsappShareButton>
                        <FacebookMessengerShareButton url={shareUrl}>
                          <li>
                            <a className="linkd">
                              <FacebookMessengerIcon size={34} round={true} />
                              <br /> Messenger
                            </a>
                          </li>
                        </FacebookMessengerShareButton>
                        <EmailShareButton url={shareUrl}>
                          <li>
                            <a className="vimo">
                              <Mail />
                              <br /> E-mail
                            </a>
                          </li>
                        </EmailShareButton>
                      </ul>
                    </div>
                  </div>
                </div>
                <Row>
                  <SwiperAutoplay data={datas} />
                </Row>
                <br />
                <Row>
                  <Col>
                    {!datas?.Previous || datas?.Previous.length === 0 ? (
                      <h4> {t("no previous post")} </h4>
                    ) : (
                      <div className="jp_blog_single_client_main_section ms_cover">
                        <div className="jp_blog_single_client_img">
                          <img
                            height="200px"
                            src={
                              datas?.Previous.photo_file &&
                              datas?.Previous.photo_file
                            }
                            alt="blog_client"
                          />
                        </div>
                        <div className="jp_blog_single_client_cont">
                          <h3>{datas?.Previous.title}</h3>
                          <div className="lang_apply_btn author_btn">
                            <ul>
                              <li>
                                <Link
                                  to={`/dataNews/${webmasterTitle}/topics/${datas?.Previous?.id}`}
                                >
                                  <i className="flaticon-left-arrow"></i>
                                  {t("read more")}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </Col>
                  <Col>
                    {!datas?.Next || datas?.Next.length === 0 ? (
                      <h4> {t("no next post")} </h4>
                    ) : (
                      <div className="jp_blog_single_client_main_section ms_cover">
                        <div className="jp_blog_single_client_img">
                          <img
                            height="200px"
                            src={
                              datas?.Next.photo_file &&
                              datas?.Next.photo_file
                            }
                            alt="blog_client"
                          />
                        </div>
                        <div className="jp_blog_single_client_cont">
                          <h3>{datas?.Next.title}</h3>
                          <div className="lang_apply_btn author_btn">
                            <ul>
                              <li>
                                <Link
                                  to={`/dataNews/${webmasterTitle}/topics/${datas?.Next?.id}`}
                                >
                                  <i className="flaticon-right-arrow"></i>
                                  {t("read more")}
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                <Comment t={t} dispatch={dispatch} />
              </div>
            ) : (
              <div className="col-lg-9">
                <center>
                  <Spinner color="primary" />
                </center>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmartendId;
